import * as ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = [];
export const formHasTicketFieldObjectType = form => Boolean(form.formFieldGroups.find(fieldGroup => Boolean(fieldGroup.fields.find(field => field.propertyObjectType === 'TICKET'))));
export default function connectedForms(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CONNECTED_FORMS_SUCCESS:
      return action.payload.filter(formHasTicketFieldObjectType);
    default:
      return state;
  }
}